import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../globalModule/assets/close-circle.svg'
import _imports_1 from '../../globalModule/assets/workflow.svg'
import _imports_2 from '../../globalModule/assets/save.svg'
import _imports_3 from '../../globalModule/assets/paper-plane.svg'


const _hoisted_1 = { class: "heading-div" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Code View", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  class: "icon-button",
  target: "_blank",
  title: "Report Bug or Issue",
  href: "https://docs.google.com/forms/d/e/1FAIpQLSfOkqKunFuJRsI8CqNlRKKNSrbBK56zWB2gMz0H9IVgP0hy0w/viewform"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1)
const _hoisted_10 = { class: "filetree-monaco-container" }
const _hoisted_11 = { class: "file-tree-column-container" }
const _hoisted_12 = { class: "open-text" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  id: "editor",
  class: "editor-style"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileTreeExplorer = _resolveComponent("FileTreeExplorer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "icon-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
      }, _hoisted_3),
      _createElementVNode("button", {
        class: "icon-button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openCanvas()))
      }, _hoisted_5),
      _hoisted_6,
      _createElementVNode("button", {
        class: "icon-button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveCurrentFile()))
      }, _hoisted_8),
      _hoisted_9
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_FileTreeExplorer, { onFileOpened: _ctx.onFileOpened }, null, 8, ["onFileOpened"]),
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.openText), 1)
      ]),
      _hoisted_13
    ])
  ], 64))
}